<template>
	<svg
		fill="none"
		height="28"
		version="1.1"
		viewBox="0 0 90 28"
		width="90">
		<circle
			cx="14"
			cy="14"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<circle
			cx="76"
			cy="14"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<rect
			fill="#000000"
			height="6"
			width="44"
			x="23"
			y="11" />
	</svg>
</template>
